export const handleOtherCategoryId = (
  service_category_id: number,
): number | null => {
  return service_category_id === 0 ? null : service_category_id;
};
